<template>
  <div>
      <jc-upload
        @mouseenter.native="showShade=true"
        @mouseleave.native="showShade=false"
        v-loading="loading"
        class="avatar-uploader"
        :action="uploadUrl"
        :data="uploadData"
        list-type="picture"
        :show-file-list="false"
        :on-success="handleSuccess"
        :before-upload="beforeUpload"
        id="noPersonStepThirdBusiness">
        <img v-if="upload.imgUrl" :src="upload.imgUrl" class="avatar">
        <i v-else class="jc-icon-plus avatar-uploader-icon"></i>
        <div class="upload-back" v-show="showShade && upload.imgUrl">
          <div class="preview" @click.stop="dialogVisible=true"><i class="jc-icon-view" @click.stop="dialogVisible=true"></i></div>
          <div class="delete"><i class="jc-icon-delete2" @click.stop="deleteImg"></i></div>
        </div>
      </jc-upload>
     <!--图片放大预览弹窗-->
    <jc-dialog v-model="dialogVisible" size="small" title="预览" :modal-append-to-body='false' :close-on-click-modal="false">
      <img :src="upload.imgUrl" style="width: 100%;">
    </jc-dialog>
  </div>
</template>
<script>
import outMsg from '@/mixins/message-mixins.js'
export default {
  name: 'sk-upload',
  props: {
    value: {
      type: Object,
      require: true
    },
    uploadData: Object,
    limit: Number
  },
  components: {},
  mixins: [outMsg],
  data() {
    return {
      upload: {
        imgUrl: '',
        attachmentId: ''
      },
      uploadUrl: '/record/fileupload/uploadfile',
      showShade: false,
      dialogVisible: false,
      loading: false
    }
  },
  watch: {
    value(val) {
      this.upload = val
    },
    upload: {
      deep: true,
      handler(val) {
        this.$emit('input', val)
      }
    }
  },
  computed: {},
  mounted() {},
  created() {
    this.upload = this.value
  },
  filters: {},
  methods: {
    beforeUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg'
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isJPG) {
        this.outMsg('error', '上传图片只能是 JPG 格式！')
      }
      if (!isLt5M) {
        this.outMsg('error', '上传图片大小不能超过 5MB！')
      }
      if (isJPG && isLt5M) {
        this.loading = true
      } else {
        return false
      }
    },
    handleSuccess(res) {
      if (res && res.code == 0) {
        this.upload.imgUrl = res.result.url
        this.upload.attachmentId = res.result.attId
        this.outMsg('success', '上传成功')
        this.loading = false
      } else {
        let errorMsg = '上传失败！'
        if (res && res.msg) {
          errorMsg = res.msg
        }
        this.outMsg('error', errorMsg)
        this.loading = false
      }
    },
    handlePictureCardPreview() {
      this.dialogVisible = true
    },
    handleRemove() {
      this.upload.imgUrl = ''
    }
  }
}
</script>
<style>
.avatar-uploader {
  height: 94px;
  width: 94px;
  border: 1px dashed #ccc;
  border-radius: 4px;
  position: relative;
}
.jc-upload--picture img {
  width: 100%;
}
.jc-upload--picture-card {
  height: 94px;
  width: 94px;
  line-height: 94px;
  vertical-align: middle;
  position: relative;
  overflow: hidden;
}
.jc-upload--picture-card img {
  z-index: 0;
  position: absolute;
  height: 94px;
  width: 94px;
  left: -1px;
  top: -1px;
}
.avatar-uploader-icon {
  background: none;
  height: 92px;
  width: 92px;
  line-height: 92px;
}
.upload-back {
  /* display: block !important; */
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 11;
}
.upload-back > div {
  height: 18px;
  width: 18px;
  display: inline-block;
  margin: 36px 8px 0 8px;
}
.upload-back > div i {
  font-size: 18px;
  display: block;
  color: white;
}
</style>
